import React, { useMemo, useState } from "react";
import { D } from "../ui";
import { REGION_GEO } from "../../../lib/jawselRegions";

// Kue potong (donat SVG) sebaran warga asli per kota — warna mengikuti warna wilayah di peta beranda (REGION_GEO).
const R = 70, RI = 42, CX = 90, CY = 90;
const titik = (a, r) => [CX + r * Math.cos(a), CY + r * Math.sin(a)];
function irisan(a0, a1) {
  const [x0, y0] = titik(a0, R), [x1, y1] = titik(a1, R), [u0, v0] = titik(a0, RI), [u1, v1] = titik(a1, RI), besar = a1 - a0 > Math.PI ? 1 : 0;
  return `M${x0},${y0} A${R},${R} 0 ${besar} 1 ${x1},${y1} L${u1},${v1} A${RI},${RI} 0 ${besar} 0 ${u0},${v0} Z`;
}

export function KueKota({ cities, card, cardTitle }) {
  const [hov, setHov] = useState(null);
  const { total, iris } = useMemo(() => {
    const total = cities.reduce((s, c) => s + c.warga, 0);
    let a = -Math.PI / 2;
    const iris = [...cities].sort((x, y) => y.warga - x.warga).filter(c => c.warga > 0).map(c => {
      const sudut = (c.warga / total) * Math.PI * 2, a0 = a, a1 = a + sudut; a = a1;
      return { ...c, a0, a1, pct: Math.round((c.warga / total) * 1000) / 10, warna: REGION_GEO[c.city_id]?.color || D.gray };
    });
    return { total, iris };
  }, [cities]);
  const aktif = hov !== null ? iris[hov] : null;

  return (
    <div data-testid="kue-kota" style={card}>
      <b style={cardTitle}>Sebaran Warga</b><span style={{ display: "block", fontSize: 11, color: D.sub, fontWeight: 600, marginTop: 2 }}>persentase warga asli per kota</span>
      {total === 0 ? <p style={{ margin: "22px 0 4px", fontSize: 12.5, color: D.sub }}>Belum ada warga asli.</p> : (
        <div style={{ display: "flex", alignItems: "center", gap: 16, marginTop: 14 }}>
          <svg data-testid="kue-svg" viewBox="0 0 180 180" style={{ width: 132, height: 132, flex: "none" }} onMouseLeave={() => setHov(null)}>
            {iris.length === 1
              ? <circle cx={CX} cy={CY} r={(R + RI) / 2} fill="none" stroke={iris[0].warna} strokeWidth={R - RI} />
              : iris.map((s, i) => <path key={s.city_id} data-testid={`kue-iris-${s.city_id}`} d={irisan(s.a0 + 0.012, s.a1 - 0.012)} fill={s.warna} opacity={hov === null || hov === i ? 1 : 0.35}
                  style={{ transition: "opacity .15s, transform .15s", transformOrigin: `${CX}px ${CY}px`, transform: hov === i ? "scale(1.04)" : "none", cursor: "pointer" }} onMouseEnter={() => setHov(i)} />)}
            <text x={CX} y={CY - 4} textAnchor="middle" fontSize={aktif ? 22 : 24} fontWeight={800} fill={D.ink} style={{ letterSpacing: -0.8 }}>{aktif ? `${aktif.pct}%` : total}</text>
            <text x={CX} y={CY + 14} textAnchor="middle" fontSize={9.5} fontWeight={700} fill={D.sub}>{aktif ? aktif.city_name : "warga asli"}</text>
          </svg>
          <ul data-testid="kue-legenda" style={{ listStyle: "none", margin: 0, padding: 0, flex: 1, minWidth: 0, display: "flex", flexDirection: "column", gap: 6 }}>
            {iris.map((s, i) => (
              <li key={s.city_id} data-testid={`kue-legenda-${s.city_id}`} onMouseEnter={() => setHov(i)} onMouseLeave={() => setHov(null)}
                style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 12, fontWeight: 700, color: D.ink, opacity: hov === null || hov === i ? 1 : 0.45, transition: "opacity .15s", cursor: "default" }}>
                <span style={{ width: 10, height: 10, borderRadius: 3, background: s.warna, flex: "none" }} />
                <span style={{ flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{s.city_name}</span>
                <span style={{ color: D.sub, fontWeight: 600, fontSize: 11 }}>{s.warga}</span>
                <b style={{ width: 40, textAlign: "right", color: D.blue }}>{s.pct}%</b>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
